<template>
  <b-card>
    <b-table
      :fields="fields"
      :items="updates"
    >
      <template #cell(state)="data">
        <b-badge
          pill
          :variant="getVariant(data.item.state)"
        >
          <span style="text-transform: capitalize">
            {{ $t(data.item.state) }}
          </span>
        </b-badge>
      </template>
      <template #cell(date)="data">
        {{ data.item.date.toDate().toLocaleDateString('fi') }}
      </template>
      <template #cell(processer)="data">
        <span style="text-transform: capitalize">
          {{ data.item.processer }}
        </span>
      </template>
      <template #cell(content)="data">
        <ul
          class="m-0 p-0 small"
          style="list-style: none"
        >
          <li
            v-for="(item, index) in data.item.content"
            :key="index"
          >
            {{ onConvertCamelCase(item) }} <br>
          </li>
        </ul>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BBadge,
} from 'bootstrap-vue'
import { onConvertCamelCase } from '@hw-core/utils'

export default {
  components: {
    BCard, BTable, BBadge,
  },
  props: {
    contractData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    updates() {
      return this.contractData.updates
    },
    fields() {
      return [
        {
          key: 'state', label: this.$t('shifts_calendar.table_headers.state'), tdClass: 'width-15 table-custom-style',
        },
        {
          key: 'date', label: this.$t('shifts_calendar.table_headers.date'), tdClass: 'width-30 table-custom-style',
        },
        {
          key: 'processer', label: this.$t('shifts_calendar.table_headers.processer'), tdClass: 'width-15 table-custom-style',
        },
        {
          key: 'content', label: this.$t('shifts_calendar.table_headers.content'), tdClass: 'width-40 table-custom-style',
        },
      ]
    },
  },
  methods: {
    getVariant(state) {
      let result = ''
      switch (state) {
        case 'created':
          result = 'info'
          break
        case 'booked':
          result = 'warning'
          break
        case 'unverified':
          result = 'danger'
          break
        case 'removed':
          result = 'danger'
          break
        case 'cancelled':
          result = 'danger'
          break
        case 'verified':
          result = 'primary'
          break
        case 'updated':
          result = 'warning'
          break
        case 'confirmed':
          result = 'success'
          break
        default:
          result = 'secondary'
      }
      return result
    },
    onConvertCamelCase,
  },
}
</script>

<style>

</style>
